import * as constants from './constants';

const initialState = {
  attributes: {},
  error: null
};

const remoteConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_REMOTE_CONFIGURATION_REQUEST:
      return state;
    case constants.FETCH_REMOTE_CONFIGURATION_SUCCESS:
      return {...state, attributes: action.data.data};
    case constants.FETCH_REMOTE_CONFIGURATION_FAIL:
      return { ...state, error: action.error };
    default:
      return state;
  }
};

export default remoteConfigurationReducer;
